import React from 'react';

export function Spinner({
  label = 'Loading…',
}: {
  label?: string;
}): React.ReactElement {
  return (
    <div className="bo-spinner" role="status" aria-live="polite">
      <span className="bo-spinner-dot" aria-hidden />
      <span className="bo-spinner-sr">{label}</span>
    </div>
  );
}
